import React from "react";
import "./Agents.css"; // <-- you will create this file

const agentsData = [
  {
    id: 1,
    name: "Emily Watson",
    role: "Luxury Property Specialist",
    img: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde",
    icon: "fa-solid fa-user-tie",
  },
  {
    id: 2,
    name: "James Carter",
    role: "Commercial Real Estate Expert",
    img: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
    icon: "fa-solid fa-building",
  },
  {
    id: 3,
    name: "Sophia Miller",
    role: "Residential Property Consultant",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
    icon: "fa-solid fa-house-chimney",
  },
];

export default function Agents() {
  return (
    <section className="agents-section">
      <h2 className="section-title">
        <i className="fa-solid fa-users"></i> Meet Our Agents
      </h2>

      <div className="agents-container">
        {agentsData.map((agent, index) => (
          <div
            className="agent-card fade-in"
            style={{ animationDelay: `${index * 0.3}s` }}
            key={agent.id}
          >
            <img src={agent.img} alt={agent.name} className="agent-img" />

            <div className="agent-info">
              <i className={`${agent.icon} agent-icon`}></i>
              <h3>{agent.name}</h3>
              <p>{agent.role}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
